import { render } from "./cpt-dataV-decoration-option.vue?vue&type=template&id=55599ee2&scoped=true"
import script from "./cpt-dataV-decoration-option.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-decoration-option.vue?vue&type=script&lang=js"

import "./cpt-dataV-decoration-option.vue?vue&type=style&index=0&id=55599ee2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55599ee2"]])

export default __exports__